import React, { useMemo } from 'react';
import { EllipseIcon } from 'src/components/shared/elements/icons/EllipseIcon';
import { Presenter } from './Presenter';

export const Paginator: React.FC<{
  total: number;
  current: number;
  shouldScroll?: boolean;
  fromFeaturedDetail?: boolean;
  pageIndexClickHandler: (page: number, shouldScroll: boolean, fromFeaturedDetail?: boolean) => void;
}> = ({ total, current, shouldScroll = false, fromFeaturedDetail = false, pageIndexClickHandler }) => {
  const pageNumberList = useMemo(() => {
    const pages: (number | React.JSX.Element)[] = [];
    let showPageRange = 2;
    const determinePageRange = () => {
      if (current === total) {
        return 4;
      } else if (current === 1 || current === 2 || current === total - 1) {
        return 3;
      } else {
        return 2;
      }
    };
    const addPages = (range: number) => {
      for (let page = Math.max(1, current - range); page <= Math.min(current + range, total); page++) {
        pages.push(page);
      }
    };

    showPageRange = determinePageRange();
    addPages(showPageRange);
    if (current === 1 && current + showPageRange < total) {
      pages.push(<EllipseIcon />);
      pages.push(total);
    }

    return pages;
  }, [current, total]);

  const isFirstPage = current === 1;
  const isLastPage = current === total;

  const goToFirstPage = () => pageIndexClickHandler(1, shouldScroll, fromFeaturedDetail);
  const goToPreviousPage = () => pageIndexClickHandler(current - 1, shouldScroll);
  const goToNextPage = () => pageIndexClickHandler(current + 1, shouldScroll, fromFeaturedDetail);
  const goToDesignatedPage = (page: number) => pageIndexClickHandler(page, shouldScroll, fromFeaturedDetail);

  if (total <= 1) return null;

  return (
    <Presenter
      pageNumberList={pageNumberList}
      current={current}
      isFirstPage={isFirstPage}
      isLastPage={isLastPage}
      goToFirstPage={goToFirstPage}
      goToPreviousPage={goToPreviousPage}
      goToNextPage={goToNextPage}
      goToDesignatedPage={goToDesignatedPage}
    />
  );
};
